function ProductViewCarouselPhotosCtrl() {
    const ctrl = this;

    ctrl.carouselInit = function (carousel) {
        ctrl.carousel = carousel;
    };
}

export default ProductViewCarouselPhotosCtrl;
